module.exports = __webpack_public_path__ + "img/reduza-reuse-recicle-respeite.svg";